import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import SelectableNotePart from 'notebook/mediocre/selection/block/SelectableNotePart';

export default function AssayDataNotePart(props: AssayDataNotePartProps): JSX.Element {
  return (
    <SelectableNotePart
      className={css(styles.selectableNotePart)}
      indentation={props.indentation}
      blockDragAndDropReason="Runs do not support uploading files via drag-and-drop."
    >
      {props.includeWrapper ? (
        <div className="resultsAttachment-wrapper">
          <div
            className={classNames('resultsAttachment-container', {
              'resultsAttachment-container--draft': props.showValidationSideBar,
            })}
          >
            {props.children}
          </div>
        </div>
      ) : (
        props.children
      )}
    </SelectableNotePart>
  );
}
interface AssayDataNotePartProps {
  children: React.ReactNode;
  includeWrapper: boolean;
  indentation: number;
  blockDragAndDropReason?: string;
  showValidationSideBar?: boolean;
}
AssayDataNotePart.propTypes = {
  children: PropTypes.node.isRequired,
  includeWrapper: PropTypes.bool.isRequired,
  indentation: PropTypes.number.isRequired,
};

const styles = StyleSheet.create({
  selectableNotePart: {flex: '0 0 auto'},
});
